import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiCheckCircle, BiQr, BiLineChart, BiCodeAlt } from 'react-icons/bi';

const QR_FLOW_URL = 'https://qr-flow.eu';

const QrFlowHeader = () => {
    const { t } = useTranslations();

    return (
        <section className="qr-flow-header">
            <div className="qr-flow-header__decoration qr-flow-header__decoration--top" />
            <div className="qr-flow-header__decoration qr-flow-header__decoration--bottom" />

            <div className="container qr-flow-header__content">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="right" delay={50}>
                            <span className="qr-flow-header__badge">{t('qrFlow_header_badge')}</span>
                            <h1 className="qr-flow-header__title">{t('qrFlow_header_title')}</h1>
                            <p className="qr-flow-header__description">{t('qrFlow_header_description')}</p>

                            <div className="qr-flow-header__features">
                                <div className="qr-flow-header__feature-item">
                                    <BiCheckCircle />
                                    <span>{t('qrFlow_header_feature1')}</span>
                                </div>
                                <div className="qr-flow-header__feature-item">
                                    <BiCheckCircle />
                                    <span>{t('qrFlow_header_feature2')}</span>
                                </div>
                                <div className="qr-flow-header__feature-item">
                                    <BiCheckCircle />
                                    <span>{t('qrFlow_header_feature3')}</span>
                                </div>
                            </div>

                            <div className="qr-flow-header__buttons">
                                <a
                                    href={`${QR_FLOW_URL}/register/`}
                                    className="qr-flow-header__btn-primary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('qrFlow_header_cta_primary')}
                                </a>
                                <a
                                    href={QR_FLOW_URL}
                                    className="qr-flow-header__btn-secondary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('qrFlow_header_cta_secondary')}
                                </a>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="left" delay={100}>
                            <div className="qr-flow-header__cards">
                                <div className="qr-flow-header__card">
                                    <BiQr />
                                    <h3>{t('qrFlow_header_card1_title')}</h3>
                                    <p>{t('qrFlow_header_card1_desc')}</p>
                                </div>
                                <div className="qr-flow-header__card">
                                    <BiLineChart />
                                    <h3>{t('qrFlow_header_card2_title')}</h3>
                                    <p>{t('qrFlow_header_card2_desc')}</p>
                                </div>
                                <div className="qr-flow-header__card">
                                    <BiCodeAlt />
                                    <h3>{t('qrFlow_header_card3_title')}</h3>
                                    <p>{t('qrFlow_header_card3_desc')}</p>
                                </div>
                                <div className="qr-flow-header__card qr-flow-header__card--highlight">
                                    <p className="qr-flow-header__trial">{t('qrFlow_header_trial')}</p>
                                    <p className="qr-flow-header__trial-desc">{t('qrFlow_header_trial_desc')}</p>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QrFlowHeader;
